import { Card, CardContent } from "@/components/ui/card";
import { BarChart3, Users, FileText, Plane, Globe, CreditCard } from "lucide-react";

const BusinessDemoSection = () => {
  const demoFeatures = [
    {
      icon: BarChart3,
      title: "Un tableau de bord interactif",
      description: "Vision globale des collaborateurs à l'étranger, des points, des évolutions…"
    },
    {
      icon: Users,
      title: "Gérez vos collaborateurs et leur localisation",
      description: "Ajout de collaborateurs, répartition par pays, nombre de demandes…"
    },
    {
      icon: FileText,
      title: "Centralisez toutes les demandes de télétravail",
      description: "Suivi clair et actionnable de toutes les demandes en cours ou passées."
    },
    {
      icon: Plane,
      title: "Suivi avancé des voyages & données collaborateur",
      description: "Durée du séjour, assurance, VPN, contact d'urgence, notifications…"
    },
    {
      icon: Globe,
      title: "Vision par pays & alertes sécurité",
      description: "Niveau de risque, météo, heure locale, news locales, alertes MAE."
    },
    {
      icon: CreditCard,
      title: "Gestion des Nest Points",
      description: "Gouvernance RH sur les règles de points, plafonds, et flexibilité manuelle."
    }
  ];

  return (
    <section className="text-center">
      <div className="mb-16">
        <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
          Dashboard de pilotage RH
        </h2>
        <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          Vue d'ensemble temps réel de tous vos collaborateurs en télétravail international avec KPIs et alertes.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {demoFeatures.map((feature, index) => (
          <div key={index} className="relative">
            <Card className="text-center hover:shadow-card transition-shadow duration-300 h-full">
              <CardContent className="pt-8 pb-6">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-bold">
                    {index + 1}
                  </div>
                </div>
                <div className="mx-auto w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 mt-4">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <h3 className="font-semibold text-lg mb-3 text-foreground">{feature.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
              </CardContent>
            </Card>
            {index < demoFeatures.length - 1 && index % 3 !== 2 && (
              <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                <div className="w-6 h-0.5 bg-primary/30"></div>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default BusinessDemoSection;